
namespace Matrix.Indexation {

    @Serenity.Decorators.registerClass()
    export class IndexRorDialog extends SiteEntityDialog<IndexRorRow, any> {
        protected getFormKey() { return IndexRorForm.formKey; }
        protected getIdProperty() { return IndexRorRow.idProperty; }
        protected getLocalTextPrefix() { return IndexRorRow.localTextPrefix; }
        protected getService() { return IndexRorService.baseUrl; }
        protected getDeletePermission() { return IndexRorRow.deletePermission; }
        protected getInsertPermission() { return IndexRorRow.insertPermission; }
        protected getUpdatePermission() { return IndexRorRow.updatePermission; }

        protected form = new IndexRorForm(this.idPrefix);

    }
}